import React, { useState } from 'react';
import {
  Collapse,
  UploadList,
  UploadZone,
  useBoolean,
  VStack,
} from '@wegroup/design-system';
import useUpload, {
  UploadResponse,
} from '../../../../../common/src/hooks/useUpload';
import { useDocExtractionMimeTypes } from '@toolkit/src/features/document-extraction/api/getMimeTypes';

const mimeTypesFallback = ['application/pdf', 'text/csv'];

interface Props {
  file?: UploadResponse;
  onUpload?: (file?: UploadResponse) => void;
  showUpload?: boolean;
}

const ExtractionForm: React.FC<Props> = ({
  onUpload = () => null,
  file,
  showUpload = true,
}) => {
  const { uploadFile } = useUpload();
  const [filePreview, setFilePreview] = useState<File>();
  const [isLoading, setIsLoading] = useBoolean();
  const { data: mimeTypes, isLoading: isLoadingMimeTypes } =
    useDocExtractionMimeTypes();

  const handleUpload = async (file: File) => {
    setFilePreview(file);
    setIsLoading.on();
    const uploadObject = await uploadFile(file);
    setIsLoading.off();
    if (uploadObject) {
      onUpload(uploadObject);
    }
  };

  return (
    <VStack align="stretch">
      <Collapse in={showUpload}>
        <UploadZone
          accept={mimeTypes?.items || mimeTypesFallback}
          onFilesAccepted={handleUpload}
          isLoading={isLoadingMimeTypes}
          maxFileSize={10000000} // 10MB
        />
      </Collapse>
      <UploadList
        file={filePreview}
        isLoading={isLoading}
        onRemove={() => {
          onUpload();
          setFilePreview(undefined);
        }}
      />
    </VStack>
  );
};

export default ExtractionForm;
